import { RcTypography, styled } from '@ringcentral/juno';

export const Container = styled.div`
  padding-bottom: 28px;
`;

export const Title = styled(RcTypography)`
  margin-bottom: 12px;
`;
